import React, { useEffect, useState, useRef } from 'react';
import Player from './../player/Player';
import Performances from './../player/Performances';
import Grid from '@mui/material/Grid';
import navigationStore from './../../stores/navigation';
import playerStore from './../../stores/player';
import ContainerRightBottom from './ContainerRightBottom';
import ContainerRightTop from './ContainerRightBottom';
import ContentContainer from './ContentContainer';


function ContainerRight() {

  const safeArea = navigationStore((state) => state.safeArea);

  return (
    <Grid item xs={6.5} className="muvika-container-right-grid" sx={{paddingRight: safeArea ? safeArea.right + "px" : 0}}>
      <ContentContainer id="muvika-player-content-container" onScrollDown={() => {
      }} isFinished={true} >
        <Player id="muvika-player" className="muvika-container-right-top" style={{ width: "100%" }} />
        <ContainerRightBottom />
      </ContentContainer>
    </Grid>
  );
}

export default ContainerRight;